import { RcClasses } from '../../../../foundation';
export var RcOutlineTextFieldInputClasses = RcClasses(['input', 'root', 'focused', 'disabled', 'error'], 'RcOutlineTextFieldInput');
export var RcOutlineTextFieldSpaces = {
    small: {
        outside: 3,
        inside: 2,
        y: 1,
    },
    medium: {
        outside: 4,
        inside: 3,
        insideLeft: 4,
        y: 2,
    },
    large: {
        outside: 4,
        inside: 3,
        insideLeft: 4,
        y: 3,
    },
};
export var RcOutlineTextFieldLabelMargins = {
    small: 5,
    medium: 5.5,
    large: 6,
};
export var RcOutlineTextFieldHeights = {
    small: 32,
    medium: 40,
    large: 48,
};
export var RcOutlineTextFieldFontStyles = {
    small: 'body1',
    medium: 'subheading1',
    large: 'subheading1',
};
export var RcOutlineTextFieldIconSizes = {
    small: 'small',
    medium: 'medium',
    large: 'medium',
};
